import React, { useEffect, useState } from 'react';
import moment from 'moment';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import { TextFieldDate as TextFieldDateDayMonth, TextFieldNoneDate as TextFieldNoneDateDayMonth } from './style.js';
import { CssDateField } from 'components/InputYupAndMui/constant.js';
import { useForm, useWatch } from 'react-hook-form';

const FORMAT = 'DD/MM';

const DateMonth = (props) => {
  const { control } = useForm();
  const { label, valueDefault, onChangeHandle, name, error, isRequired, placeholder, sizeDate, disable } = props;
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setValue(valueDefault);
  }, [valueDefault]);

  const handleChangeDate = (newValue) => {
    onChangeHandle(newValue);
  };

  // Watch value of input date
  const valueWatch = useWatch({
    control,
    name: name,
  });

  return (
    <>
      <CssDateField labelspace={valueWatch ? 0 : '-1px'}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            name={name}
            open={open}
            inputFormat="dd/MM"
            disabled={disable ? disable : false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            views={['day', 'month']}
            value={value}
            label={
              <React.Fragment>
                {placeholder && !value ? placeholder : label}
                {isRequired && label ? <sup>*</sup> : ''}
              </React.Fragment>
            }
            onChange={handleChangeDate}
            renderInput={(params) => {
              if (label) {
                return (
                  <TextFieldDateDayMonth
                    {...params}
                    error={error ? true : false}
                    inputProps={{
                      readOnly: true,
                    }}
                    size={sizeDate ? sizeDate : ''}
                    value={value ? moment(value).format(FORMAT) : null}
                    placeholder={placeholder}
                  />
                );
              }
              return (
                <TextFieldNoneDateDayMonth
                  {...params}
                  error={error ? true : false}
                  inputProps={{
                    readOnly: true,
                  }}
                  size={sizeDate ? sizeDate : ''}
                  value={value ? moment(value).format(FORMAT) : null}
                  placeholder={placeholder}
                />
              );
            }}
          />
        </LocalizationProvider>
      </CssDateField>
      <p className="error-input error">{error}</p>
    </>
  );
};

export default DateMonth;
